import i18n from "i18next";
import type { FC } from "react";
import { useNavigate } from "react-router";

import type { TerminalVersionEntity } from "src/app/features/TerminalVersion/types/TerminalVersionEntity";
import { PrimaryButton } from "../../../../../components/Buttons/components/ActionButton";
import type { ButtonProps } from "../../../../../components/FeatureButtons/types";
import { ResourceName } from "../../../../../core/router/config/ResourceName";
import { BASE_PATH } from "../../../../../core/router/types/routerTypes";

export const ViewDiffButton: FC<ButtonProps<TerminalVersionEntity>> = ({ item }) => {
    const navigate = useNavigate();
    const onClick = () => navigate(`${BASE_PATH}/${ResourceName.TERMINAL_VERSIONS}/${item?.id}`);

    return (
        <PrimaryButton name="viewDiff_button" onClick={onClick} disabled={false}>
            {i18n.t("button.viewDiff")}
        </PrimaryButton>
    );
};
